import React from 'react'
import TableLayout from '../../components/TableLayout'
import Search from '../../components/Search'
import { Col, Row, Form, DatePicker, Statistic, Select, Typography, Button, Tooltip, Spin } from 'antd'
import API from '../../services/API'
import { currencyFormat, methodCode } from '../../services/Utils'
const current = JSON.parse(localStorage.getItem('sucursal'))
import moment from 'moment'
import { param } from 'jquery'
const { Paragraph } = Typography

const { RangePicker } = DatePicker
const { Option } = Select

const ReportCreditContainer = props => {
    const [loading, setLoading] = React.useState(true)
    const [payments, setPayments] = React.useState([])
    const [period, setPeriod] = React.useState('day')
    const [subsidiary, setSubsidiary] = React.useState({
        id: current ? current.id : '',
        name: current ? current.name : '',
    })
    const [dateRange, setDateRange] = React.useState({
        startDate: moment(),
        endDate: moment().add(1, 'days'),
    })

    const handleLoading = isLoading => {
        setLoading(isLoading)
    }

    const getParams = () => {
        let newParams = ''
        newParams += '&filter[is_credit]=1'
        if (subsidiary && subsidiary.id && subsidiary.id != 'all') {
            newParams += `&filter[subsidiary_id]=${subsidiary.id}`
        }
        if (dateRange.startDate && dateRange.endDate) {
            const endDate = `${dateRange.endDate.format('YYYY-MM-DD')} 23:59:59`
            newParams += `&dateRange=${dateRange.startDate.format('YYYY-MM-DD')},${endDate}`
        }
        if (customer && customer.id && customer.id != 'all') {
            newParams += `&filter[customer_id]=${customer.id}`
        }
        return newParams
    }

    const [params, setParams] = React.useState(getParams())
    const [customer, setCustomer] = React.useState({ id: '', name: '' })

    // React.useEffect(() => {
    //     const newParams = getParams()
    //     setParams(newParams)

    //     if (params) {
    //         API.get(`/api/orders/info_sales?${newParams}`)
    //             .then(response => {
    //                 setPayments(response.data)
    //             })
    //             .catch(error => {
    //                 console.error(error)
    //             })
    //     }
    // }, [subsidiary.id, dateRange.startDate])
    const infoSales = (query = '') => {
        const newParams = getParams()
        setParams(newParams)
        setLoading(true)
        if (params) {
            API.get(`/api/orders/info_sales?${params}${query}`)
                .then(response => {
                    setPayments(response.data)
                })
                .catch(error => {
                    console.error(error)
                }).finally(()=>{
                   setLoading(false)
                })
        }
    }

    React.useEffect(() => {
        const storedFilters = localStorage.getItem('filtersCredit')
        console.log('filtersCredit:: storedFilters', storedFilters)
        if (storedFilters) {
            const { payments, period, subsidiary, dateRange, customer } = JSON.parse(storedFilters)
            setPayments(payments)
            setPeriod(period)
            setSubsidiary(subsidiary)
            setDateRange({
                startDate: moment(dateRange.startDate),
                endDate: moment(dateRange.endDate),
            })
            setCustomer(customer)
        }
    }, [])

    React.useEffect(() => {
        const newParams = getParams()
        setParams(newParams)
        const filtersState = {
            payments,
            period,
            subsidiary: {
                id: subsidiary.id,
                name: subsidiary.name,
            },
            dateRange: {
                startDate: dateRange.startDate ? dateRange.startDate.format() : moment().format(),
                endDate: dateRange.endDate ? dateRange.endDate.format() : moment().format(),
            },
            customer: {
                id: customer.id,
                name: customer.name,
            },
        }
        localStorage.setItem('filtersCredit', JSON.stringify(filtersState))
    }, [customer, subsidiary.id, dateRange.startDate, dateRange.endDate])

    const onChange = (reload = false, query = '') => {
        if (reload) {
            infoSales(query)
        }
    }

    const clean = () => {
        setPayments([])
        setPeriod('default')
        setSubsidiary({ id: current ? current.id : '', name: current ? current.name : '' })
        setCustomer({ id: '', name: '' })
    }

    const columns = [
        {
            title: 'ID único',
            dataIndex: 'unique_id',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Sucursal',
            dataIndex: 'subsidiary.name',
            sorter: false,
            filtered: false,
        },
        {
            title: 'Cliente',
            dataIndex: 'customer.social_reason',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Cajero',
            dataIndex: 'user.full_name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Cantidad',
            dataIndex: 'total_item_count',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Subtotal',
            dataIndex: 'sub_total',
            sorter: true,
            filtered: true,
            dataType: 'money',
        },
        {
            title: 'Impuestos',
            dataIndex: 'tax_amount',
            sorter: true,
            filtered: true,
            dataType: 'money',
        },
        {
            title: 'Total',
            dataIndex: 'grand_total',
            sorter: true,
            filtered: true,
            dataType: 'money',
        },

        {
            title: 'Fecha',
            dataIndex: 'captured_at',
            dataType: 'date',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Estado',
            dataIndex: 'order_status_id',
            dataType: 'status',
            sorter: true,
            filtered: true,
            render: (label, record) => {
                if (record && record.status) {
                    return record.status.name
                }
                return ''
            },
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            sorter: false,
            filtered: false,
        },
    ]

    return (
        <>
            <TableLayout
                title="Reporte de ventas a credito"
                columns={columns}
                resource="v2/order"
                params={params}
                handleLoading={handleLoading}
                actions={['excel', 'pdf', 'show', 'pay']}
                actionUrl={{
                    show: '/orders/show',
                }}
                additionalFilter={getData => (
                    <Row gutter={24}>
                        <Col lg={4} md={12} sm={24}>
                            <Form.Item label="Sucursal">
                                <Search
                                    value={subsidiary.name}
                                    placeholder="Sucursal"
                                    onSearch={value => `/api/subsidiaries?filter[active]&filter[name]=${value}`}
                                    allOptions
                                    onChange={(key, value) => {
                                        setSubsidiary(value)
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col lg={4} md={12} sm={24}>
                            <Form.Item label="Periodo">
                                <Select
                                    style={{ width: '100%' }}
                                    value={period}
                                    onChange={(key, value) => {
                                        switch (key) {
                                            case 'day':
                                                setDateRange({
                                                    startDate: moment(),
                                                    endDate: moment().add(1, 'days'),
                                                })
                                                break
                                            case 'week':
                                                setDateRange({
                                                    startDate: moment().startOf('week'),
                                                    endDate: moment().endOf('week'),
                                                })
                                                break
                                            case 'month':
                                                setDateRange({
                                                    startDate: moment().startOf('month'),
                                                    endDate: moment().endOf('month'),
                                                })
                                                break
                                            case 'year':
                                                setDateRange({
                                                    startDate: moment().startOf('year'),
                                                    endDate: moment().endOf('year'),
                                                })
                                                break
                                            default:
                                                break
                                        }

                                        setPeriod(key)
                                    }}
                                    placeholder="Periodo"
                                >
                                    <Option key="day" value="day">
                                        Día actual
                                    </Option>
                                    <Option key="week" value="week">
                                        Semana actual
                                    </Option>
                                    <Option key="month" value="month">
                                        Mes actual
                                    </Option>
                                    <Option key="year" value="year">
                                        Año actual
                                    </Option>
                                    <Option key="dayCustom" value="dayCustom">
                                        Dia Personalizado
                                    </Option>
                                    <Option key="custom" value="custom">
                                        Rango Personalizado
                                    </Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        {period == 'dayCustom' ? (
                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Fecha">
                                    <DatePicker
                                        style={{ width: 200, marginBottom: 10, display: 'block' }}
                                        // value={dateFilter}
                                        value={dateRange.endDate}
                                        placeholder="Fecha"
                                        onChange={date => {
                                            setDateRange({
                                                startDate: date,
                                                endDate: date,
                                            })
                                        }}
                                        format="YYYY-MM-DD"
                                        onPressEnter={() => {}}
                                    />
                                </Form.Item>
                            </Col>
                        ) : null}
                        {period == 'custom' ? (
                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Rango de fechas">
                                    <RangePicker
                                        value={[dateRange.startDate, dateRange.endDate]}
                                        onChange={dateRange => {
                                            setDateRange({
                                                startDate: dateRange[0],
                                                endDate: dateRange[1],
                                            })
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        ) : null}
                        <Col lg={4} md={12} sm={24}>
                            <Form.Item label="Cliente">
                                <Search
                                    value={customer.social_reason}
                                    placeholder="Cliente"
                                    onSearch={value => `/api/customers?filter[q]=${value}`}
                                    label="social_reason"
                                    keyName="id"
                                    allOptions
                                    onChange={(key, value) => {
                                        setCustomer(value)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={4} md={12} sm={24} style={{ paddingTop: '39.9999px' }}>
                            <Form.Item>
                                <Tooltip title="Limpiar" placement="top">
                                    <Button type="primary" style={{ marginRight: '5px' }} onClick={() => clean()}>
                                        Limpiar
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Buscar" placement="top">
                                    <Button type="primary" style={{ marginRight: '5px' }} onClick={getData}>
                                        Buscar
                                    </Button>
                                </Tooltip>
                            </Form.Item>
                        </Col>
                        {/* <Col lg={ 12} md={12} sm={24}> */}
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns:
                                    period === 'dayCustom' || period === 'custom' ? 'auto' : 'auto auto',
                                justifyContent: 'center',
                                gap: '20px',
                                paddingRight: '12px',
                            }}
                        >
                            {!loading && payments.length > 0 ? (
                                <>
                                    {[
                                        ['debit_card', 'credit_card', 'cash', 'total'],
                                        ['transfer', 'check', 'credit', 'total_invoiced'],
                                    ].map((group, columnIndex) => (
                                        <div
                                            key={columnIndex}
                                            style={{ display: 'grid', gridTemplateRows: 'repeat(4, 1fr)' }}
                                        >
                                            {group.map(itemName => {
                                                const item = payments?.find(item => item.name === itemName)
                                                if (item) {
                                                    return (
                                                        <div
                                                            key={itemName}
                                                            style={{
                                                                display: 'grid',
                                                                gridTemplateColumns: '100px auto',
                                                                row: 4,
                                                                borderTop:
                                                                    itemName === 'total' ||
                                                                    itemName === 'total_invoiced'
                                                                        ? '2px solid #e8e8e8'
                                                                        : 'none',
                                                            }}
                                                        >
                                                            <div>
                                                                <Paragraph strong style={{ marginBottom: 0 }}>
                                                                    {methodCode(item.name)}
                                                                </Paragraph>
                                                            </div>
                                                            <div>
                                                                <Paragraph strong style={{ marginBottom: 0 }}>
                                                                    {currencyFormat(item.value)}
                                                                </Paragraph>
                                                            </div>
                                                        </div>
                                                    )
                                                } else {
                                                    return null
                                                }
                                            })}
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <Spin spinning={loading} marginBottom={10} marginRight={10} />
                            )}
                        </div>
                        {/* </Col> */}
                    </Row>
                )}
                onChange={onChange}
                shouldValidateParams={true}
            />
        </>
    )
}

export default ReportCreditContainer
